import { useState, useRef, useEffect } from "react";
import { useThemeContext } from "../theme/ThemeContext";

function AnimatedNumber({ value, suffix = "" }) {
  const [displayed, setDisplayed] = useState(value);
  const prev = useRef(value);
  useEffect(() => {
    const start = prev.current;
    const end   = value;
    prev.current = end;
    if (start === end) return;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / 700, 1);
      const eased    = 1 - Math.pow(1 - progress, 3);
      setDisplayed(Math.round(start + (end - start) * eased));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [value]);
  return <>{displayed}{suffix}</>;
}

export default function StatsBar({ stats, successRate }) {
  const { SA, isDark } = useThemeContext();

  const cells = [
    { label: "AT RISK",   value: stats.pax },
    { label: "EXPEDITED", value: stats.exp },
    { label: "BAGS EXP",  value: stats.bags },
    { label: "SUCCESS",   value: successRate, suffix: "%", highlight: true },
  ];

  return (
    <div style={{
      display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr",
      borderTop: `1px solid ${isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"}`,
    }}>
      {cells.map((s, i) => (
        <div key={s.label} style={{
          padding: "12px 0", textAlign: "center",
          borderRight: i < 3 ? `1px solid ${SA.borderGray}` : "none",
        }}>
          <div style={{
            fontSize: 22, fontFamily: "'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif",
            color: s.highlight ? SA.lightSilver : SA.white,
            fontWeight: 300, letterSpacing: "0.02em",
          }}>
            <AnimatedNumber value={s.value} suffix={s.suffix ?? ""} />
          </div>
          <div style={{
            fontSize: 8, color: SA.silver, letterSpacing: "0.22em",
            marginTop: 4, textTransform: "uppercase",
            fontFamily: "'HelveticaNeueStd','Barlow','Helvetica Neue',Arial,sans-serif",
          }}>
            {s.label}
          </div>
        </div>
      ))}
    </div>
  );
}
